module.exports = __webpack_public_path__ + "img/campaign-free-shipping.f96b4c56.svg";